import { render } from "./SaleHorseLamp.vue?vue&type=template&id=5c474d06&scoped=true"
import script from "./SaleHorseLamp.vue?vue&type=script&lang=js"
export * from "./SaleHorseLamp.vue?vue&type=script&lang=js"

import "./SaleHorseLamp.vue?vue&type=style&index=0&id=5c474d06&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c474d06"]])

export default __exports__